import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    Input,
    OnInit,
    OnChanges,
} from "@angular/core";

import { ProductEnvironment } from "@hermes/api-model-product-environment";
import { LOCALE } from "@hermes/app-core";
import { Locale } from "@hermes/locale";
import { RouterService } from "@hermes/utils-generic/services/router";

@Component({
    selector: "h-agec-search-result",
    templateUrl: "./agec-search-result.component.html",
    styleUrls: ["./agec-search-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgecSearchResultComponent implements OnInit, OnChanges {
    @Input({ required: true })
    public product!: ProductEnvironment;

    public productImageSrcSet: Array<{ srcSet: string; mediaQuery: string }> =
        [];
    public urlSustainableDevelopment: string = "";

    constructor(
        @Inject(LOCALE) private readonly locale: Locale,
        private routerService: RouterService,
    ) {}

    public ngOnInit(): void {
        this.urlSustainableDevelopment = this.getUrlSustainableDevelopment();
    }

    public ngOnChanges(): void {
        this.productImageSrcSet = [
            {
                mediaQuery: "(min-width: 320px) and (max-width: 768px)",
                srcSet: `${this.product?.imageUrl}?hei=207&wid=414`,
            },
            {
                mediaQuery: "(min-width: 768px)",
                srcSet: `${this.product?.imageUrl}?hei=414&wid=414`,
            },
        ];
    }

    public getUrlSustainableDevelopment(): string {
        return `${this.locale.urlPrefix}/content/129521-developpement-durable/`;
    }

    public clickOnSustainableDevelopmentLink(event: MouseEvent): void {
        event.preventDefault();
        this.routerService.spaRedirect(this.urlSustainableDevelopment);
    }
}
